import config from "./config.json";

import apiClient from "./apiClient";

import {
  TransactinPostEnterPhoneType,
  TransactinPostVerifyPhoneType,
  TransactinGetSettingType,
  TransactionMessagePostType,
  TransactionGetRulesType,
  TransactionGetBlogType,
  TransactionGetPostType,
  TransactionPostBlogCommentType,
  TransactionGetGalleryType,
  TransactionGetAlbumType,
  TransactionGetCoachsType,
  TransactionGetCoachType,
  TransactionGetEventsType,
  TransactionGetEventType,
  TransactionGetCartType,
  TransactionPostCartType,
  TransactionGetProfileType,
  TransactionUpdateProfileType,
  TransactionGetTownType,
  TransactionPostCoachType,
  TransactionDeleteCartType,
  TransactionGetTagType,
  TransactionGetMyRulesType,
  TransactionGetMyEventsType,
  TransactionGetOrdersType,
  TransactionPostOrdersType,
  TransactionPostSansType,
  TransactionDeleteSansType,
  TransactionGetStudentsType,
  TransactionPostStudentsType,
  TransactionGetResponsibleStudentsType,
  TransactionPostResponsibleStudentsType,
  TransactionUpdateDocumentsType,
  TransactionGetCoachPlansType,
  TransactinLoginType,
  TransactionPostCoachGalleryType,
  TransactionPatchPasswordType,
  TransactionSetPasswordType,
  TransactionGetTeamMembersType
} from "../Structures";

// ============================================================================================

const _getAbsoluteUrl = (url: string) => {
  return `${config.serverUrl}/${url}`;
};

// #region ======================================== Login ====================================================

export const TransactinLogin: TransactinLoginType = (params) => {
  return apiClient.post(_getAbsoluteUrl("login/password/"), params);
};

export const TransactionSetPassword: TransactionSetPasswordType = (params) => {
  return apiClient.post(_getAbsoluteUrl("set-password/"), params);
};

export const TransactinPostEnterPhone: TransactinPostEnterPhoneType = (
  params
) => {
  return apiClient.post(_getAbsoluteUrl("login/otp/"), params);
};


export const TransactionPostResendCode: TransactinPostEnterPhoneType = (
  params
) => {
  return apiClient.post(_getAbsoluteUrl("login/otp/"), params);
};

export const TransactionPostVerifyPhone: TransactinPostVerifyPhoneType = (
  params
) => {
  return apiClient.post(_getAbsoluteUrl("check-code/"), params);
};

// #endregion ============================================================================================

// #region =========================================== Setting =================================================

export const TransactionSettingGet: TransactinGetSettingType = () => {
  return apiClient.get(_getAbsoluteUrl("setting/"));
};

export const TransactionGetTeamMembers: TransactionGetTeamMembersType = () => {
  return apiClient.get(_getAbsoluteUrl("our-team/"));
};

// #endregion ============================================================================================

// #region =========================================== User Message =================================================

export const TransactionMessagePost: TransactionMessagePostType = (params) => {
  return apiClient.post(_getAbsoluteUrl("user/message/"), params);
};

// #endregion ============================================================================================

// #region ======================================= Rules =====================================================

export const TransactionRulesGet: TransactionGetRulesType = () => {
  return apiClient.get(_getAbsoluteUrl("rules/"));
};

// #endregion ============================================================================================

// #region ======================================= Blog =====================================================

export const TransactionGetBlog: TransactionGetBlogType = () => {
  return apiClient.get(_getAbsoluteUrl("blog/"));
};

export const TransactionGetPost: TransactionGetPostType = (postId: string) => {
  return apiClient.get(_getAbsoluteUrl(`blog/${postId}/`));
};

export const TransactionPostBlogComment: TransactionPostBlogCommentType = (
  params
) => {
  return apiClient.post(_getAbsoluteUrl(`blog/add-comment/`), params);
};

// #endregion ============================================================================================

// #region ======================================= Gallery =====================================================

export const TransactionGetGallery: TransactionGetGalleryType = () => {
  return apiClient.get(_getAbsoluteUrl("gallery/"));
};

export const TransactionGetAlbum: TransactionGetAlbumType = (
  albumId: string
) => {
  return apiClient.get(_getAbsoluteUrl(`gallery/${albumId}/`));
};

// #endregion ============================================================================================

// #region ======================================= Coach =====================================================

export const TransactionGetCoachs: TransactionGetCoachsType = () => {
  return apiClient.get(_getAbsoluteUrl("coachs/"));
};

export const TransactionGetCoach: TransactionGetCoachType = (
  coachId: string
) => {
  return apiClient.get(_getAbsoluteUrl(`coachs/${coachId}/`));
};

export const TransactionPostCoach: TransactionPostCoachType = (form) => {
  return apiClient.post(_getAbsoluteUrl("coachs/"), form);
};

export const TransactionUpdateCoach: TransactionPostCoachType = (form) => {
  return apiClient.put(_getAbsoluteUrl("coachs/"), form);
};

// #endregion ============================================================================================

// #region ======================================= Event =====================================================

export const TransactionGetEvents: TransactionGetEventsType = () => {
  return apiClient.get(_getAbsoluteUrl("events/"));
};

export const TransactionGetEvent: TransactionGetEventType = (
  eventId: string
) => {
  return apiClient.get(_getAbsoluteUrl(`events/${eventId}/`));
};

// #endregion ============================================================================================

// #region ======================================= Cart =====================================================

export const TransactionGetCart: TransactionGetCartType = () => {
  return apiClient.get(_getAbsoluteUrl("cart/"));
};

export const TransactionPostCart: TransactionPostCartType = (
  product_id,
  cart_detail_type
) => {
  return apiClient.post(_getAbsoluteUrl("cart/"), {
    product_id,
    cart_detail_type,
  });
};

export const TransactionDeleteCart: TransactionDeleteCartType = (
  cart_detail_id
) => {
  return apiClient.delete(_getAbsoluteUrl("cart/"), {
    data: { cart_detail_id },
  });
};

// #endregion ============================================================================================

// #region ======================================= Profile =====================================================

export const TransactionGetProfile: TransactionGetProfileType = () => {
  return apiClient.get(_getAbsoluteUrl("user/"));
};

export const TransactionUpdateProfile: TransactionUpdateProfileType = (
  form
) => {
  return apiClient.put(_getAbsoluteUrl("user/"), form);
};

export const TransactionPatchPassword: TransactionPatchPasswordType = (
  params
) => {
  return apiClient.patch(_getAbsoluteUrl("user/"), params);
};

export const TransactionUpdateDocuments: TransactionUpdateDocumentsType = (
  form
) => {
  return apiClient.put(_getAbsoluteUrl("user/documents/"), form);
};

// #endregion ============================================================================================

// #region ======================================= Town =====================================================

export const TransactionGetTown: TransactionGetTownType = () => {
  return apiClient.get(_getAbsoluteUrl("towns/"));
};

// #endregion ======================================= Town =====================================================

// #region ======================================= Tag =====================================================

export const TransactionGetTag: TransactionGetTagType = () => {
  return apiClient.get(_getAbsoluteUrl("tags/"));
};

// #endregion ======================================= Tag =====================================================

// #region ======================================= My Rules =====================================================

export const TransactionGetMyRules: TransactionGetMyRulesType = () => {
  return apiClient.get(_getAbsoluteUrl("my-rules/"));
};

// #endregion ======================================= My Rules =====================================================

// #region ======================================= My Events =====================================================

export const TransactionGetMyEvents: TransactionGetMyEventsType = () => {
  return apiClient.get(_getAbsoluteUrl("my-events/"));
};

// #endregion ======================================= My Events =====================================================

// #region ======================================= My Orders =====================================================

export const TransactionPostOrders: TransactionPostOrdersType = (form) => {
  return apiClient.post(_getAbsoluteUrl("order/"), form);
};

export const TransactionGetOrders: TransactionGetOrdersType = () => {
  return apiClient.get(_getAbsoluteUrl("order/"));
};

// #endregion ======================================= My Orders =====================================================

// #region ======================================= Coach Sans =====================================================+

export const TransactionPostSans: TransactionPostSansType = (params) => {
  return apiClient.post(_getAbsoluteUrl("coach/sans/"), params);
};

export const TransactionDeleteSans: TransactionDeleteSansType = (params) => {
  return apiClient.delete(_getAbsoluteUrl("coach/sans/"), {
    data: { sans_id: params },
  });
};

// #endregion ======================================= Coach Sans =====================================================

// #region ======================================= Coach Students =====================================================

export const TransactionGetStudents: TransactionGetStudentsType = () => {
  return apiClient.get(_getAbsoluteUrl("coach/students/"));
};

export const TransactionPostStudents: TransactionPostStudentsType = (
  params
) => {
  return apiClient.post(_getAbsoluteUrl("coach/students/"), params);
};

// #endregion ======================================= Coach Students =====================================================

// #region ======================================= Responsible Students =====================================================

export const TransactionGetResponsibleStudents: TransactionGetResponsibleStudentsType =
  () => {
    return apiClient.get(_getAbsoluteUrl("responsible/"));
  };

export const TransactionPostResponsibleStudents: TransactionPostResponsibleStudentsType =
  (params) => {
    return apiClient.post(_getAbsoluteUrl("responsible/"), params);
  };

// #endregion ======================================= Responsible Students =====================================================

// #region ======================================= Responsible Students =====================================================

export const TransactionGetCoachPlans: TransactionGetCoachPlansType = () => {
  return apiClient.get(_getAbsoluteUrl("coach/plans/"));
};

// #endregion ======================================= Responsible Students =====================================================

// #region ======================================= Responsible Students =====================================================

export const TransactionPostCoachGallery: TransactionPostCoachGalleryType = (
  form
) => {
  return apiClient.post(_getAbsoluteUrl("coach/images/"), form);
};

export const TransactionDeleteCoachGallery = ({ id }: { id: number }) => {
  return apiClient.delete(_getAbsoluteUrl("coach/images/"), {
    data: {
      gallery_id: id,
    },
  });
};

// #endregion ======================================= Responsible Students =====================================================
